import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("CRASH:", error);
    console.error("CRASH stack:", errorInfo?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      console.error("CRASH (render):", this.state.error?.message, this.state.error?.stack);
      return (
        <div
          className="min-h-screen flex items-center justify-center px-6"
          style={{ background: "var(--zen-bg, #F9F9F7)" }}
        >
          <div className="text-center max-w-md">
            <h1
              className="font-heading text-3xl md:text-4xl tracking-tight mb-4"
              style={{ color: "var(--zen-text, #2C2C2C)" }}
            >
              Something went wrong
            </h1>
            <p
              className="text-sm mb-8 leading-relaxed"
              style={{ color: "var(--zen-sub, #6B6B6B)" }}
            >
              The app hit an unexpected error. Your data is safe.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="zen-btn zen-btn-primary px-6 py-3 text-sm"
            >
              Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
